export default __webpack_public_path__ + "static/media/Clasicos.29513b39.jpg";